import React from "react";
import {
  Box,
  Container,
  Typography,
  Chip,
} from "@mui/material";
import {
  FiberManualRecord,
} from "@mui/icons-material";
import { styled, keyframes } from "@mui/material/styles";

const CUSTOMERS = [
  { id: 2, name: "tau", logo: "/customers/tau.png" },
  { id: 1, name: "Ceat", logo: "/customers/ceat-tyres-seeklogo.png" },
  { id: 3, name: "Ceat", logo: "/customers/DAW.png" },
];

// Animations
const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

// Styled Components
const BackgroundBox = styled(Box)({
  position: "relative",
  minHeight: "auto",
  background: "linear-gradient(180deg, #000000 0%, #0a0a0a 50%, #000000 100%)",
  overflow: "hidden",
  paddingTop: "60px",
  paddingBottom: "60px",
});

const GradientOrb = styled(Box)(({ top, left, bottom, right, color }) => ({
  position: "absolute",
  width: 500,
  height: 500,
  borderRadius: "50%",
  background: color,
  filter: "blur(100px)",
  pointerEvents: "none",
  top,
  left,
  bottom,
  right,
}));

const GridPattern = styled(Box)({
  position: "absolute",
  inset: 0,
  opacity: 0.05,
  backgroundImage: `linear-gradient(rgba(148, 163, 184, 0.1) 1px, transparent 1px),
                     linear-gradient(90deg, rgba(148, 163, 184, 0.1) 1px, transparent 1px)`,
  backgroundSize: "50px 50px",
  pointerEvents: "none",
});

const CustomerItem = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  padding: "16px",
  transition: "all 0.3s ease",
  opacity: 1,
  flexShrink: 0,
  "&:hover": {
    "& .customer-logo": {
      transform: "scale(1.1)",
    },
  },
});

const LogoImage = styled("img")({
  width: 80,
  height: 80,
  objectFit: "contain",
  transition: "all 0.3s ease",
  filter: "none",
  opacity: 1,
  "&:hover": {
    transform: "scale(1.05)",
  },
});

const HomepageCustomers = () => {
  return (
    <BackgroundBox>
      {/* Background Elements */}
      <GradientOrb top="50%" left={-256} color="rgba(193, 227, 40, 0.08)" />
      <GradientOrb bottom="50%" right={-256} color="rgba(193, 227, 40, 0.08)" />
      <GridPattern />

      <Container maxWidth="xl" sx={{ position: "relative" }}>
        {/* Section Header */}
        <Box textAlign="center" mb={4}>
          {/* Badge */}
          <Chip
            icon={
              <FiberManualRecord
                sx={{
                  fontSize: 8,
                  animation: `${pulse} 2s ease-in-out infinite`,
                }}
              />
            }
            label="TRUSTED BY LEADING BRANDS"
            sx={{
              background: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(193, 227, 40, 0.3)",
              color: "#c1e328",
              fontWeight: 700,
              letterSpacing: 3.2,
              fontSize: "0.555rem",
              mb: 2,
            }}
          />

          {/* Title */}
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
              fontWeight: 700,
              color: "#fff",
              letterSpacing: -0.5,
              mb: 1,
            }}
          >
            Our{" "}
            <Box
              component="span"
              sx={{
                background:
                  "linear-gradient(135deg, #c1e328 0%, #b5d028 50%, #a8c728 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Customers
            </Box>
          </Typography>
        </Box>

        {/* Customers Grid */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 1, md: 2 },
            py: 2,
          }}
        >
          {CUSTOMERS.map((customer) => (
            <CustomerItem key={customer.id}>
              <LogoImage 
                className="customer-logo" 
                src={customer.logo} 
                alt={customer.name}
              />
            </CustomerItem>
          ))}
        </Box>
      </Container>
    </BackgroundBox>
  );
};

export default HomepageCustomers;

